import type { ReactNode } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { hasRuntimeSettingsAccess } from './runtime-settings-access-policy';

interface RuntimeSettingsAccessGateProps {
  children: ReactNode;
  role: string | null | undefined;
}

export function RuntimeSettingsAccessGate({ children, role }: RuntimeSettingsAccessGateProps) {
  if (hasRuntimeSettingsAccess(role)) return children;
  return (
    <Card className="rounded-[var(--radius-surface-4xl)] border-border/70">
      <CardHeader>
        <ShieldCheckIcon className="text-muted-foreground" />
        <CardTitle>Zone réservée aux administrateurs</CardTitle>
        <CardDescription>
          La configuration runtime est limitée aux administrateurs de la plateforme.
        </CardDescription>
      </CardHeader>
      <CardContent className="text-sm text-muted-foreground">
        Le backend applique également ce contrôle d’accès sur chaque endpoint.
      </CardContent>
    </Card>
  );
}
